import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'what_annual_worker_turnover_percent'

export const dataPointDefinition = {
  retracedId: 'what_annual_worker_turnover_percent',
  name: 'What is the annual worker turnover in percent? ',
  description:
    'Calculate based on the past 12 months. Divide the number of workers terminated during the most recent 12 month period by the number of workers at the beginning of that 12 month period. ',
  meta: {
    slcpMeta: {
      key: 'fp-wor-36',
      number: 'FP-WOR-44',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'fp-wor-36', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29050,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
